import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {FilterContext} from "../../../../../components/filters/DashboardFilterContextProvider.jsx";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useLegacyPeriodReportError} from "../../Layout/LegacyPeriodReportBoundary.jsx";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import toast from "react-hot-toast";
import SeeMore from "../../../../../components/SeeMore.jsx";
import {useTopChannelColumns} from "../../../topChannelColumns.js";
import DataGrid2 from "../../../../../components/datagrid/DataGrid2.jsx";
import ReportingSnapshotStatus from "../../../../admin/ReportingSnapshotStatus.jsx";
import {snapshotRowsForPublishedDays} from "../../../../../utils/reportingSnapshotAvailability.js";

export default function ChannelPerformancePanel({project}) {
    let {t} = useTranslation();
    let {et} = useLegacyPeriodReportError();

    let {since, until, centresAllowListed, domainsAllowListed} = useContext(FilterContext);
    const {customerWholesaleRequestFilter} = useContext(FilterContext);

    let [data, setData] = useState(null);
    let [dataLoading, setDataLoading] = useState(true);
    let authorityConfiguration = useAuthorityConfiguration()

    let columns = useTopChannelColumns(project);

    useEffect(() => {
        if (!project) {
            return;
        }

        let active = true;
        setDataLoading(true);
        setData(null);

        new ErpCalculationApi(authorityConfiguration)
            .channelPerformance({
                projectId: project.id,
                erpFilter: {
                    ...customerWholesaleRequestFilter,
                    since: since.format('YYYY-MM-DD'),
                    until: until.format('YYYY-MM-DD'),
                    selectedCentreIds: centresAllowListed,
                    selectedDomainIds: domainsAllowListed,
                },
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
                setDataLoading(false);
            })
            .catch(e => {
                if (!active) {
                    return;
                }

                et(e).then((message) => { if (message) toast.error(message); });
            });

        return () => {
            active = false;
        };

    }, [project?.id, since, until, centresAllowListed, domainsAllowListed, customerWholesaleRequestFilter]);

    const visibleChannels = snapshotRowsForPublishedDays(data?.topChannels ?? [], data?.snapshot);

    return (<LoadingComponent
            loading={dataLoading || !data}
            className="comp__roundedBox reporting-surface rounded-lg flex flex-col justify-between col-span-12 xl:col-span-6 bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700"
        >
            <header
                className={'px-5 py-4 border-b border-gray-100 dark:border-gray-700/60'}>
                <h2 className={'font-semibold text-gray-800 dark:text-gray-100'}>
                    {t('orders.top-channels')}
                </h2>
            </header>
            <div className="px-3 pt-3"><ReportingSnapshotStatus snapshots={data?.snapshot}/></div>
            <div className={'p-3'}>
                {<SeeMore heightClass={'h-[223px]'} active={(visibleChannels.length ?? 0) >= 5}>
                    <DataGrid2
                        showHeader={true}
                        columns={columns}
                        dataSource={visibleChannels}
                    />
                </SeeMore>}
            </div>
        </LoadingComponent>
    );

}
